import { render } from "./OrderTypeList.vue?vue&type=template&id=ee62f4f0&scoped=true"
import script from "./OrderTypeList.vue?vue&type=script&lang=js"
export * from "./OrderTypeList.vue?vue&type=script&lang=js"

import "./OrderTypeList.vue?vue&type=style&index=0&id=ee62f4f0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee62f4f0"]])

export default __exports__